/* ================= modified section: ================= */
import p5 from "p5";
/* ============= end of modified section =============== */

/* ================= modified section: ================= */
const t = (fontName, s) => {
	let font, cnv, title;

	s.preload = () => {
		const distPath = import.meta.env.MODE.match(/(SERVE|STYLEGUIDE)/)
			? ""
			: "/frontend/dist/";
		const fontPath = `${distPath}/assets/${fontName}.woff`;
		font = s.loadFont(fontPath);
	};
	/* ============= end of modified section =============== */

	s.setup = () => {
		var div = s.drawingContext.canvas.parentElement;
		let info = getDOMinfo();
		cnv = s.createCanvas(div.offsetWidth, div.offsetHeight + info.titSize);
		s.pixelDensity(window.devicePixelRatio);
		s.smooth();
		title = new Lettering(info);

		/* ================= modified section: ================= */
		// s.triggerAni() // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TRIGGERS ANIMATION
		/* ============= end of modified section =============== */
	};

	s.draw = () => {
		s.clear();
		title.draw();
	};

	s.windowResized = () => {
		resetDiv(
			s.drawingContext.canvas.parentElement.parentElement,
			s.drawingContext.canvas.parentElement,
		);
		s.setup();
	};

	s.triggerAni = () => {
		title.triggerAni();
	};

	function getDOMinfo() {
		let parent = s.drawingContext.canvas.parentElement.parentElement;

		/* ================= modified section: ================= */
		let tit = parent.children[0];
		tit.style = "color: rgba(255, 255, 255, 0.0);"; // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< PAINTING ORIGINAL TEXT TRASNPARENT (SHOULD IT BE DONE ON THE CSS?)

		const titComputedStyle = getComputedStyle(tit, null);
		const isUpperCase =
			titComputedStyle.textTransform.toLowerCase() === "uppercase";

		let info = {
			tit: tit,
			box: tit.getBoundingClientRect(),
			titSize: parseFloat(titComputedStyle.getPropertyValue("font-size")),
			titLeading: parseFloat(titComputedStyle.getPropertyValue("line-height")),
			text: isUpperCase ? tit.innerText.toUpperCase() : tit.innerText,
		};
		/* ============= end of modified section =============== */
		return info;
	}

	class Lettering {
		constructor(info) {
			this.on = false;
			this.animate = false;
			this.fired = 0;
			this.info = info;
			this.makeImage();

			this.enter = true;
			for (let i = 0; i < this.cutouts.length; i++) {
				this.cutouts[i].enter = this.enter;
				if (this.on) {
					this.cutouts[i].scaleY = 1;
				}
			}
		}

		makeImage() {
			let b = this.info.box;
			let h = s.floor(b.height * 1.2);
			let w = s.width;
			let yCenter = b.y - cnv.elt.getBoundingClientRect().y;

			this.originalImg = s.createGraphics(w, h);
			this.originalImg.pixelDensity(s.pixelDensity());
			this.originalImg.noStroke();
			this.originalImg.fill(255);
			this.originalImg.rectMode(s.CENTER);
			this.originalImg.textFont(font);
			this.originalImg.textSize(this.info.titSize);
			this.originalImg.textLeading(this.info.titLeading);
			this.originalImg.textAlign(s.CENTER, s.CENTER);

			let dif = s.abs(this.info.titSize - this.info.titLeading) * 0.5;

			let nLines = s.round(b.height / this.info.titLeading);
			if (nLines == 1) {
				this.originalImg.text(
					this.info.text,
					this.originalImg.width * 0.5,
					b.height * 0.5 - dif,
					b.width * 2,
					h,
				);
			} else {
				this.originalImg.text(
					this.info.text,
					this.originalImg.width * 0.5,
					b.height * 0.5 - dif,
					b.width + 25,
					h,
				);
			}

			this.cutouts = [];
			let hCut = s.floor(this.info.titSize * 0.05);

			let movSize = this.info.titSize * 0.5;

			for (let y = 0; y < this.originalImg.height; y += hCut) {
				let cut = s.createImage(this.originalImg.width, hCut);
				cut.copy(
					this.originalImg,
					0,
					0,
					this.originalImg.width,
					this.originalImg.height,
					0,
					-y,
					this.originalImg.width,
					this.originalImg.height,
				);
				let posCut = s.createVector(
					s.floor(s.width * 0.5),
					s.floor(y + hCut * 0.5 + yCenter),
				);
				this.cutouts.push(new Cutout(cut, posCut, movSize));
			}
			this.originalImg.remove();
		}

		checkAnimation() {
			for (let i = 0; i < this.cutouts.length; i++) {
				if (this.cutouts[i].animate) {
					return true;
				}
			}
			return false;
		}

		endAni() {
			this.animate = false;
		}

		pushLines() {
			this.cutouts[this.fired].startAni();
			if (this.fired < this.cutouts.length - 1) {
				this.fired++;
			} else {
				this.endAni();
			}
		}

		triggerAni(activeIsMe = true) {
			if (!this.checkAnimation()) {
				this.animate = true;
				this.on = !this.on;
				this.fired = 0;
			} else {
				this.on = activeIsMe;
				this.animate = true;
				this.fired = 0;
				for (let i = 0; i < this.cutouts.length; i++) {
					this.cutouts[i].forceOut();
				}
			}
		}

		draw() {
			if (this.animate) {
				this.pushLines();
			}
			let animating = this.animate || this.checkAnimation();
			if (this.on || animating) {
				for (let i = 0; i < this.cutouts.length; i++) {
					this.cutouts[i].draw();
				}
			}
		}
	}

	class Cutout {
		constructor(img, pos0, movSize) {
			this.img = img;
			this.pos0 = pos0.copy();
			this.pos = pos0.copy();
			this.enter = true;
			this.animate = false;
			this.aniDuration = 45;
			this.aniTime = 0;
			this.distance = movSize;
			this.displace = s.createVector(0, 0);
			this.scaleY = 0;
		}

		endAni(active = null) {
			this.aniTime = 0;
			this.animate = false;
			if (active == null) {
				this.enter = !this.enter;
			} else {
				this.enter = !active;
			}
			if (this.enter) {
				this.scaleY = 0;
			} else {
				this.scaleY = 1;
			}
		}

		startAni() {
			this.animate = true;
			let d = this.distance * 2;
			if (!this.enter) {
				d = -this.distance;
			}

			this.displace = s.createVector(0, d);
			this.displace.add(this.pos0);

			if (this.enter) {
				this.pos = this.displace.copy();
			}
		}

		reset() {
			this.enter = true;
			this.animate = false;
			this.aniTime = 0;
		}

		forceOut() {
			this.aniTime = 0;
			this.enter = false;
			this.animate = false;
		}

		move() {
			let aniTime = this.aniTime;
			if (this.enter) {
				let delay = this.aniDuration * 0.75;
				aniTime -= delay;
				aniTime = s.max(aniTime, 0);
			}

			let p = s.norm(aniTime, 0, this.aniDuration);
			let pIn = easeIn(p);
			let pOut = easeOut(p);

			if (this.enter) {
				this.pos = p5.Vector.lerp(this.displace, this.pos0, pOut);
				this.scaleY = pOut;
			} else {
				this.pos = p5.Vector.lerp(this.pos0, this.displace, pIn);
				this.scaleY = 1 - pIn;
			}

			if (aniTime < this.aniDuration) {
				this.aniTime++;
			} else {
				this.endAni();
			}
		}

		draw() {
			s.noFill();
			if (this.animate) {
				this.move();
			}
			if (this.scaleY > 0) {
				s.push();
				s.translate(this.pos.x, this.pos.y);
				s.scale(1, this.scaleY);
				s.translate(-this.img.width * 0.5, -this.img.height * 0.5);
				s.image(this.img, 0, 0, this.img.width, this.img.height);
				s.pop();
			}
		}
	}

	function easeOut(x) {
		return 1 - s.pow(1 - x, 3);
	}

	function easeIn(x) {
		return x * x * x;
	}
};

var titles = [];
let d = document.getElementsByClassName("canvas-wrapper");

for (let i = 0; i < d.length; i++) {
	const newDiv = document.createElement("div");
	newDiv.id = "p5-title-" + i;
	d[i].appendChild(newDiv);

	/* ================= modified section: ================= */
	window.addEventListener("load", function() {
		resetDiv(d[i], newDiv);

		const headingComputedStyle = getComputedStyle(d[i].children[0]);
		const fontWeight = headingComputedStyle.fontWeight;
		let fontName = headingComputedStyle.fontFamily;
		fontName = fontName
			.replace(
				/Grotesk/g,
				`${fontWeight === "900" ? "GroteskBlack" : "GroteskHeavy"}`,
			)
			.replace(/(Extended|Expanded|Heavy|Black)/g, "-$1")
			.replace(/,\s?sans-serif/g, "");

		const p5Object = new p5(t.bind(this, fontName), newDiv.id);

		const waitForCanvasLoad = (p5Object) => {
			// set initial timestamp, so we can check how long we've been waiting for the canvas to load
			if (!p5Object.initiationTimestamp) {
				p5Object.initiationTimestamp = Date.now();
			}

			// jump to the next event loop
			requestAnimationFrame(() => {
				if (p5Object.canvas) {
					// if the canvas has been loaded
					// make the triggerAni function available on the canvas element of the current title
					// also make sure that the animation can only be triggered once
					p5Object.canvas.triggerAni = () => {
						if (!p5Object.wasAlreadyTriggered) {
							p5Object.triggerAni();
						}
						p5Object.wasAlreadyTriggered = true;
					};

					// dispatch an event to notify that the canvas has been loaded,
					// so the triggerAni function can be called
					const event = new Event("canvasLoaded");
					p5Object.canvas.closest(".canvas-wrapper")?.dispatchEvent(event);
				} else if (Date.now() - p5Object.initiationTimestamp < 30000) {
					// 30 seconds is the maximum time we will wait for the canvas to load
					// this is to prevent an infinite loop in case something goes wrong
					// if we are withing the time limit, call the function again
					waitForCanvasLoad(p5Object);
				}
			});
		};
		waitForCanvasLoad(p5Object);

		titles.push(p5Object);
	});
	/* ============= end of modified section =============== */
}

function resetDiv(orig, newDiv) {
	let box = orig.getBoundingClientRect();
	newDiv.style =
		"height: " +
		box.height +
		"px; width: " +
		(box.width + 20) +
		"px;" +
		"position: absolute; top: " +
		(box.top + window.scrollY - 10) +
		"px; left: " +
		(box.left - 10) +
		"px;";
}
